import React, { useState } from 'react';
import { Checkout as CheckoutComponent } from '@wix/premium-purchase-platform/@components';
import { PremiumPurchasePlatformModule, PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
import { Box } from '@wix/design-system';
import { PageHeading } from './PageHeading';
import { PageLayout } from './PageLayout';
import { SalesPromotion } from './SalesPromotion';
import { getSuccessUrl } from './utils';
import { isCoreProduct } from './types';
import styles from './CheckoutPage.scss';
import { InitialLoader } from './InitialLoader';
export function CheckoutPage(_ref) {
  var _data$products;
  let {
    msId,
    title,
    subtitle
  } = _ref;
  const {
    ApiClient
  } = PremiumPurchasePlatformModule.SDK;
  const {
    useContext
  } = PremiumPurchasePlatformModule.internals;
  const [isCheckoutReady, setIsCheckoutReady] = useState(false);
  const context = useContext();
  const {
    data,
    isLoading
  } = ApiClient.hooks.useGetPurchaseUserOffering(context);
  const product = data == null || (_data$products = data.products) == null ? void 0 : _data$products.find(isCoreProduct);
  if (!product) {
    return null;
  }
  function handleInitSuccess() {
    setIsCheckoutReady(true);
  }
  function handleSubmitSuccess() {
    window.location.replace(getSuccessUrl(msId));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, (!isCheckoutReady || isLoading) && /*#__PURE__*/React.createElement(InitialLoader, null), /*#__PURE__*/React.createElement(PageLayout, {
    gap: 4,
    hidden: !isCheckoutReady
  }, /*#__PURE__*/React.createElement(SalesPromotion, null), /*#__PURE__*/React.createElement(PageHeading, {
    title: title,
    subtitle: subtitle
  }), /*#__PURE__*/React.createElement(Box, {
    className: styles.container,
    height: "100%"
  }, /*#__PURE__*/React.createElement(CheckoutComponent.Root, {
    lineItems: [{
      productId: product.productId,
      quantity: 1,
      billingCycle: {
        cycleType: PurchaseOffering.CycleType.ONE_TIME,
        cycleDuration: {
          unit: PurchaseOffering.DurationUnit.YEAR,
          count: 1
        }
      },
      context: {
        msid: msId
      }
    }],
    checkoutProps: {
      onInitSuccess: handleInitSuccess,
      onSubmitSuccess: handleSubmitSuccess
    }
  }))));
}
//# sourceMappingURL=CheckoutPage.js.map